import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/workflows/WorkflowsClient.tsx");
